import store from '@/store';

export function checkAuth(to, from, next) {
  store.dispatch('checkAuthenticated').then(() => {
    proceed();
  });

  function proceed() {
    if (store.getters.isAuthenticated) {
      if (store.getters.currentUser != null) {
        next();
      } else {
        store.dispatch('logoutUser');

        next({
          path: 'login'
        });
      }
    } else {
      store.dispatch('logoutUser');
      next({
        path: 'login'
      });
    }
    next();
  }
}



// WEBPACK FOOTER //
// ./src/router/utils/auth.js